/**
 * AttorneyRoleLayout - Wrapper for attorney-specific pages
 * 
 * Provides:
 * - AttorneyLayout (attorney sidebar nav, header, auth)
 * - AgentNotification (single WebSocket, app-level toasts)
 * 
 * Mirrors RoleDashboardLayout but for the attorney auth path.
 * Keeps AttorneyLayout.tsx untouched.
 */

import React from 'react';
import AttorneyLayout from './AttorneyLayout';
import AgentNotification from './pipeline/AgentNotification';

interface AttorneyRoleLayoutProps {
  children: React.ReactNode;
  activeSection?: string;
  onSectionChange?: (section: string) => void;
}

export default function AttorneyRoleLayout({ children, activeSection, onSectionChange }: AttorneyRoleLayoutProps) {
  return (
    <AttorneyLayout activeSection={activeSection} onSectionChange={onSectionChange}>
      {children}
      <AgentNotification position="bottom-right" maxNotifications={4} autoDismissMs={8000} />
    </AttorneyLayout>
  );
}
